import { render } from "./AdminMailSettingsView.vue?vue&type=template&id=9e64f302&scoped=true&ts=true"
import script from "./AdminMailSettingsView.vue?vue&type=script&lang=ts"
export * from "./AdminMailSettingsView.vue?vue&type=script&lang=ts"

import "./AdminMailSettingsView.vue?vue&type=style&index=0&id=9e64f302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e64f302"]])

export default __exports__